export const Assign = (prevState, nextState) => Object.assign({}, prevState, nextState)

export const dateformat = (date, format = 'yyyy-MM-dd') => { //author: meizz
	let o = {
		"M+": date.getMonth() + 1, //月份
		"d+": date.getDate(), //日
		"H+": date.getHours(), //小时
		"m+": date.getMinutes(), //分
		"s+": date.getSeconds(), //秒
		"q+": Math.floor((date.getMonth() + 3) / 3), //季度
		"f+": date.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(format))
	format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (let k in o)
	if (new RegExp("(" + k + ")").test(format))
	format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	return format;
}

export const handleLocation = _ => {
	let s = location.search.substring(1, location.search.length)
	let search = {}
	let a = [s]
	if (s.length > 1 && s.indexOf('&') > 0 && s) {
		a = s.split('&')
	}
	a.forEach(val => {
		let b = val.split('=')
		search[b[0]] = b[1]
	})
	return search
}

// 认证微信JS-SDk
export const wxJsSDK = obj => {
	wx.config({
		beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
		debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
		appId: obj.appid, // 必填，企业微信的corpID
		timestamp: obj.timestamp, // 必填，生成签名的时间戳
		nonceStr: obj.noncestr, // 必填，生成签名的随机串
		signature: obj.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
		jsApiList: ['previewFile'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
	});
	wx.ready(function () {
		// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
		console.log('JS-SDK 认证成功')
	});
	wx.error(function (res) {
		// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
		console.log('JS-SDK 认证失败')
	});
}

//下载文件
export const dealBlob = (data, filename) => {
	const userAgent = window.navigator.userAgent
	var isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 是否手机端
	if(isMobile && userAgent.indexOf('wxwork') >= 0) {
		wx.invoke(
			"previewFile",
			{
				url: data.url, // 需要预览文件的地址(必填，可以使用相对路径)
				name: filename, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
				size: data.size // 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
			}
		);
	}else if(userAgent.indexOf('miniProgram') > 0 || window.__wxjs_environment === 'miniprogram'){// 微信小程序
		wx.miniProgram.navigateTo({
			url: '../previewFile/previewFile?path=' + encodeURIComponent(data.url),
		})
	}else{
		const protocolStr = document.location.protocol;
		console.log('非企业微信客户端打开~', protocolStr)
		//window.open(data.url)
		window.location.href = data.url;
	}
}

//下载文件
export const dealBlob2 = (b, name) => {
	 if(window.navigator.msSaveBlob){// 兼容ie11
		try{
			window.navigator.msSaveBlob(b, name);
		}catch(e){
			console.log('windows download error...')
			console.log(e);
		}
	}else{
		const aLink = document.createElement('a');
		aLink.href = window.URL.createObjectURL(b);
		aLink.download = name;
	    //此写法兼容可火狐浏览器
		document.body.appendChild(aLink);
		var evt = document.createEvent("MouseEvents");
		evt.initEvent("click", false, false);
		aLink.dispatchEvent(evt);
	    document.body.removeChild(aLink);
	}
}

//飞书 获得用户code
export const getUserCode = () => new Promise((resolve, reject) => {
	window.h5sdk.ready(() => {
		if (window.tt.requestAccess) {
			window.tt.requestAccess({
				// 网页应用 App ID
				appID: window.feishu_appid,
				scopeList: [],
				success: (res) => {
					// 用户授权后返回预授权码
					const { code } = res;
					resolve(code);
				},
				fail: (error) => {
					alert(JSON.stringify(error));
					// 需要额外根据errno判断是否为 客户端不支持requestAccess导致的失败
					const { errno, errString } = error;
					if (errno === 103) {
						// 客户端版本过低，不支持requestAccess，需要改为调用requestAuthCode
						callRequestAuthCode();
					} else {
						// 用户拒绝授权或者授权失败
					}
				},
			});
		} else { // JSSDK版本过低，不支持requestAccess，需要改为调用requestAuthCode
			callRequestAuthCode();
		}

		function callRequestAuthCode() {
			window.tt.requestAuthCode({
				// 网页应用 App ID
				appId: window.feishu_appid,
				success: (res) => {
					// 用户免登录后返回预授权码
					const { code } = res;
					resolve(code);
				},
				fail: (error) => {
					// 免登失败，返回相应的errno和errString
					const { errno, errString } = error;
				},
			});
		}
	});
})



// WEBPACK FOOTER //
// ./src/api/tools.js